import React from 'react'


const AugumentedReality = () => {

    

    return (
        <>
           <div className="inner-page-banner-area" style={{ backgroundImage: 'url("/images/About_images/about_banner.jpg")' }}>
                <div className="container">
                    <div className="pagination-area">
                        <h1>Augmented Reality Startup Course</h1>
                    </div>
                </div>
            </div>
            <h2 className='title-default-center title-bar-big-center pt-5'>Learn how to create an AR (Augmented Reality) based app</h2>

            <div className="container" id="inner-isotope">
                <div className="row featuredContainer" style={{ position: 'relative' }}>
                    <div className="terms">
                        <div className="row">
                            <div className="col-md-6 col-sm-12">
                                <h4 className='title-default-left title-bar-big-left-close'>About Augmented Reality</h4>
                                <p style={{ textAlign: 'justify' }}>
                                    Augmented Reality (AR) is a general term for a collection of technologies used to blend computer generated information with the viewer’s natural senses.
                                </p>
                                <p style={{ textAlign: 'justify' }}>
                                    AR is being used in an increasing variety of ways, from providing point-of-sale information to shoppers, tourist information on landmarks, computer enhancement of traditional printed media, service information for on-site engineers; the number of applications is huge.
                                </p>
                                <div className="row pt-3">
                                    <div className="col-lg-6 col-sm-12">
                                        <iframe width="100%" height="auto" style={{ minHeight: '200px' }} src="https://www.youtube.com/embed/1fGgHTVZC4E" frameBorder={0} gesture="media" allow="encrypted-media" allowFullScreen />
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                        <iframe width="100%" height="auto" style={{ minHeight: '200px' }} src="https://www.youtube.com/embed/Co8WGvtOlxw" frameBorder={0} gesture="media" allow="encrypted-media" allowFullScreen />
                                    </div>
                                </div>
                                <br />
                            </div>
                            <div className='col-md-6 col-sm-12'>
                                <h4 className='title-default-left title-bar-big-left-close'>
                                    What Will I Learn?
                                </h4>
                                <ul className='learning-outcomes'>
                                    <li>Skills to build beautiful real-world Augmented Reality applications from scratch.</li>
                                    <li>Have a thorough understanding of good practices and principles of Softwares &amp; Plugins and Augmented Reality Developement.</li>
                                    <li>Build amazing AR apps for Android, iPhone, Windows, Linux and Mac.</li>
                                    <li>Learn to integrate complex 3D models with your Augmented Reality application.</li>
                                    <li>Get a hands on experience of using Unity and a deep understanding of its various features.</li>
                                </ul>
                                <h4 className='title-default-left title-bar-big-left-close pt-3'>Requirements</h4>
                                <ul className='learning-outcomes'>
                                    <li>Desktop Computer / Laptop</li>
                                    <li>Android Device</li>
                                    <li>Basic Computer Knowledge</li>
                                </ul>
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
            </div >


        </>

    )
}

export default AugumentedReality